import { styled } from 'ui';

interface ContainerProps {
  isMobile: boolean;
}

export const FormContainer = styled('div')<ContainerProps>(({ theme, isMobile }) => ({
  alignItems: 'center',
  backgroundColor: 'white',
  borderRadius: isMobile ? theme.spacing(1) : 0,
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  padding: isMobile ? `${theme.spacing(4)} ${theme.spacing(2)}` : theme.spacing(8),
}));

export const MessageContainer = styled('div')<ContainerProps>(({ theme, isMobile }) => ({
  padding: isMobile ? theme.spacing(2) : theme.spacing(8),
}));
